<template>
  <ion-app>
    <ion-router-outlet id="main-content" :key="$route.fullPath"></ion-router-outlet>
  </ion-app>
</template>
<script>
import {
  IonApp,
  IonRouterOutlet,
} from "@ionic/vue";
import { defineComponent } from "vue";
import { useRoute } from "vue-router";

export default defineComponent({
  name: "App",
  components: {
    IonApp,
    IonRouterOutlet,
  },
  setup() {
    const route = useRoute();
    return {
      isSelected: (url) => (url === route.path ? "selected" : ""),
    };
  },
});
</script>
